var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{ref:"menu",staticClass:"click-menu",style:({ visibility: _vm.viewMenu?'visible':'hidden', top:_vm.top, left:_vm.left }),attrs:{"tabindex":"-1"},on:{"click":_vm.close}},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5a0bae8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generic/BlockMenu.vue
// module id = 1068
// module chunks = 6